import type { Employee, RpcClient } from "@pentacode/core";
import { GetCommonWorkDaysParams, getContractForDate, toDateString } from "@pentacode/core";

export type EmployeeSlice = Pick<Employee, "id" | "contracts">;

export async function getFixedOrCalculatedCommonWorkDays(
    api: Pick<RpcClient, "getCommonWorkDays">,
    employee: EmployeeSlice
): Promise<number[]> {
    const today = toDateString(new Date());
    const contract = getContractForDate(employee.contracts, today);
    const fixedHoursPerDay = contract && contract.fixedWorkDays && contract.hoursPerDay;
    if (fixedHoursPerDay) {
        return fixedHoursPerDay
            .map((hours, index) => {
                if (hours > 0) {
                    // sunday would correspond to position 6 in the fixedWorkDays
                    if (index === 6) return 0;
                    return index + 1;
                }
                return -1;
            })
            .filter((index) => index !== -1);
    }

    return api.getCommonWorkDays(
        new GetCommonWorkDaysParams({
            employeeId: Number(employee.id),
            before: today,
        })
    );
}
